import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from './AuthProvider'
import { PageLoader } from '@/components/PageLoader'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return <PageLoader />
  }

  if (!user) {
    const returnPath = location.pathname + location.search;
    return <Navigate to={`/login?from=${encodeURIComponent(returnPath)}`} replace />
  }

  return <>{children}</>
}
